import { Injectable, signal } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ButtonLoadingService {
  // Define a signal for loading state
  loading = signal(false);

  show(): void {
    this.loading.set(true);
  }

  hide(): void {
    this.loading.set(false);
  }
}
